import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {TaxYearsService} from "../../../shared/util/tax-years.service";
import {CopyToYearService, TaxYearService} from "../../../../swaggerServices";
import { TenantConfigService } from '../../../shared/services/tenant-config.service';
import { ConfigStateService } from '../../config/config-state.service';
import { Subscription } from 'rxjs';
import { TranslocoService} from "@jsverse/transloco";

declare var $: any;

@Component({
    selector: 'app-tax-years',
    templateUrl: './tax-years.component.html',
    styleUrls: ['./tax-years.component.scss'],
    standalone: false
})
export class TaxYearsComponent implements OnInit {
  newTaxYr: number;
  @ViewChild('newTaxYrModal') newTaxYrModal: ElementRef;
  @ViewChild('successModal') successModalEl: ElementRef;
  taxYrCreated: boolean;
  isLoading: boolean;
  taxReturnAlias: string;
  taxpayerAlias: string;
  yearLabel: string;
  uiConfig: TenantConfigService;
  subscriptions: Subscription[] = [];


  constructor(
    private taxYearsService: TaxYearsService,
    private taxYearService: TaxYearService,
    public config: ConfigStateService,
    private copyToYearService: CopyToYearService,
    private translocoService: TranslocoService
  ) {
  }

  ngOnInit() {
    this.taxYearsService.getTaxYears().subscribe((years: any) => {
      this.newTaxYr = Math.max.apply(Math, years.map(y => y.value)) + 1;
    });
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
        this.taxpayerAlias = this.uiConfig.config.taxpayerAlias
        this.yearLabel = this.uiConfig.config.yearLabel
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);
        this.translocoService.selectTranslate('tax-payer-alias').subscribe(value => this.taxpayerAlias = value);
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      })
    );
  };

  showConfirmModal() {
    $(this.newTaxYrModal.nativeElement).modal('show');
  }

  createNewTaxYr() {
    this.isLoading = true;
    this.copyToYearService.migrateToNextYear(this.newTaxYr).subscribe(() => {
        this.taxYrCreated = true;
        $(this.successModalEl.nativeElement).modal('show');
        $(this.newTaxYrModal.nativeElement).modal('hide');
        this.isLoading = false;
      },
      () => {
        $(this.newTaxYrModal.nativeElement).modal('hide');
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
